import { Component, Input, OnInit } from '@angular/core';
import { GalleryDto, Section } from '@picflow/types';
import { EmbedDisplayComponent } from '../../../gallery-shared/components/embed-display/embed-display.component';
import { assetSectionWidths } from '../../../lib/default-asset-section';
import { sleep } from '../../../lib/sleep';

@Component({
  selector: 'app-embed-section',
  templateUrl: './embed-section.component.html',
  styleUrls: ['./embed-section.component.scss'],
  standalone: true,
  imports: [EmbedDisplayComponent],
})
export class EmbedSectionComponent implements OnInit {
  @Input() section: Section;
  @Input() gallery: GalleryDto;
  url: URL;
  sectionWidth: number;

  async ngOnInit() {
    this.sectionWidth = this.section['embed_width'] || assetSectionWidths.medium;
    await sleep(0);
    this.url = this.getUrlObj(this.section.embed_url);
  }

  getUrlObj(_url: string) {
    if (!_url) return;
    try {
      return new URL(_url);
    } catch {}
  }
}
